module.exports = __webpack_public_path__ + "static/media/avatar_45.5dc540e5.svg";